import React, { useState } from 'react';

import { Box, Button, Heading, Text, ButtonPrimary, TextInput, Popover } from '@primer/components'
import { Link } from "react-router-dom";


const createCheckoutSession = function(priceId) {
  return fetch(process.env.REACT_APP_CHECKOUT_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      priceId: priceId
    })
  }).then(function(result) {
    return result.json();
  });
};


const pricings = [
  {
    title: "Individual",
    isPrimary: false,
    isFree: true,
    duration: 'forever',
    price: "Free",
    buttonLabel: "pip install django-doctor",
    features: {
      licenceUsers: "1",
      support: "No",
      ciTool: "Yes",
      browserTool: "Yes",
      autoFix: "Yes",
      commercial: "No",
    }
  },
  {
    title: "Team",
    isPrimary: true,
    isFree: false,
    duration: 'per month',
    price: "$49",
    isRibbon: true,
    buttonLabel: "Buy commercial license",
    features: {
      licenceUsers: 10,
      support: "24/7 email and chat",
      ciTool: "Yes",
      browserTool: "Yes",
      autoFix: "Yes",
      commercial: "Yes",
    }
  },
  { 
    title: "Organization",
    isPrimary: false,
    isFree: false,
    duration: 'per month',
    price: "$99",
    buttonLabel: "Buy commercial license",
    features: {
      licenceUsers: "30 (contact for more)",
      support: "24/7 email and chat",
      ciTool: "Yes",
      browserTool: "Yes",
      autoFix: "Yes",
      commercial: "Yes",
    }
  },
]

function PricingBox(props) {
  const JoinButton = props.pricing.isPrimary ? ButtonPrimary : Button 
  const [copied, setCopied] = useState(false)
  const [isInProgress, setInInProgress] = React.useState(false)
  const className = isInProgress ? 'AnimatedEllipsis' : ''
  const label = isInProgress ? 'Working' : props.pricing.buttonLabel
  const buttonProps = {className, disabled: isInProgress}

  function handleClick() {
    setInInProgress(true)
    const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
    createCheckoutSession(props.priceId).then(data => {
      stripe.redirectToCheckout({sessionId: data.sessionId})
    })
  }

  function copyCodeToClipboard(event) {
    event.target.select()
    document.execCommand("copy")
    setCopied(true)
  }

  return (
    <Box
      marginRight="15px"
      marginLeft="15px"
      paddingLeft="20px"
      paddingRight="20px"
      className="text-center pricing-box bg-white price-active col-md-4 mb-md-0 mb-4 pb-6"
    >
      {props.pricing.isRibbon && <div className="ribbon-box"><Text>Popular</Text></div> }
      <Heading as="h4" fontSize="1" className="text-uppercase">{props.pricing.title}</Heading>
      <Heading as="h1">{ props.pricing.price }</Heading>
      <Text className="text-uppercase">{ props.pricing.duration }</Text>
      <Box className="mt-6 mb-6">
        <p>CI integration: <b>{props.pricing.features.ciTool}</b></p>
        <p>Improvement engine: <b>{props.pricing.features.autoFix}</b></p>
        <p>Number of users: <b>{props.pricing.features.licenceUsers}</b></p>
        <p>Support: <b>{props.pricing.features.support}</b></p>
        <p>Commercial use: <b>{props.pricing.features.commercial}</b></p>
      </Box>


      {
        props.pricing.isFree
          ? <TextInput onClick={copyCodeToClipboard} style={{"textAlign": "center"}} value={props.pricing.buttonLabel} />
          : <JoinButton as="button" onClick={handleClick} {...buttonProps}>{label}</JoinButton>
      }

      <Popover open={copied} caret="top">
        <Popover.Content>
          <Text className="p-0">Copied to clipboard.</Text>
        </Popover.Content>
      </Popover>
    </Box>
  );
}


export default function Component(props) {
  return (
    <Box className="container-lg" padding="0">
      <Heading
        as="h2"
        marginBottom="40px"
        style={{textTransform: 'uppercase'}}
        textAlign="center"
        className="text-white pt-12"
      >{ props.title }</Heading>
      { props.showDescription && <Text className="text-white ml-3 f3 text-center" as="p">Command line linter and code improvements engine. <Link to="/self-hosted" className="text-white">Read more</Link>.</Text>}
      <Box marginTop="50px" className="d-md-flex">
        <PricingBox pricing={pricings[0]} />
        <PricingBox pricing={pricings[1]} priceId={process.env.REACT_APP_STRIPE_PRODUCT_ID_SELF_HOSTED_TEAM} />
        <PricingBox pricing={pricings[2]} priceId={process.env.REACT_APP_STRIPE_PRODUCT_ID_SELF_HOSTED_ORGANISATION}  />
      </Box>
      {
        props.showCatalogue && (
          <Box className="position-relative pt-md-6 pt-4 pl-4 pr-4 text-white">
            <Text as="h3" className="text-center">
                <Link to="/" className="text-white">or read about our SaaS offering with GitHub integration</Link>
            </Text>
          </Box>
        )
      }
    </Box>
  )
}


Component.defaultProps = {
  title: "Our Price"
}